import React from 'react';
import Header from './Header';
import Footer from './Footer';
import GlobalStyles from '../../globalStyles';
import styled from 'styled-components';

const Main = styled.main`
  min-height: calc(100vh - 150px);
`;

const Layout = ({ children }) => {
  return (
    <>
      <GlobalStyles />
      <Header />
      <Main>{children}</Main>
      <Footer />
    </>
  );
};

export default Layout; 